import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import { Layout, BlogPostHeader, FooterCta, Section, PostGrid, CategoryNav, Link } from 'components';
import * as styles from './category.module.scss';

const BlogPost = ({ location, data }) => {
  const {
    category: { uid, data: categoryData, first_publication_date: publishedDate, last_publication_date: updatedDate },
    categoryPosts: { nodes: posts = {} },
    otherPosts: { nodes: otherData },
    newsletterCta: { data: ctaData },
  } = data;

  const {
    meta_title: metaTitle,
    meta_description: metaDesc,
    open_graph_image: ogImage,
    category_name: categoryName,
  } = categoryData;

  const seo = {
    title: metaTitle?.text || `${categoryName?.text}`,
    description: metaDesc?.text || `Read insightful articles on ${categoryName?.text}`,
    ogImage: ogImage?.url,
    publishedDate,
    updatedDate,
  };

	const maxPerPage = 4;
  const [postsToShow, setPostsToShow] = useState(maxPerPage);
  const [visiblePosts, setVisiblePosts] = useState([...posts].slice(0, maxPerPage));

  const handleShowMore = (event) => {
    event.preventDefault();
    setPostsToShow(postsToShow + maxPerPage);
  };

  useEffect(() => {
    setVisiblePosts([...posts].slice(0, postsToShow));
  }, [postsToShow]);

  const otherBlogPosts = otherData;

  console.log('visiblePosts.length', visiblePosts.length);

  return (
    <Layout location={location} seo={seo}>
      <BlogPostHeader title={categoryName} />
      <CategoryNav />
      <Section className={styles.postContainer} largeContainer>
        {visiblePosts.length === 0 && <p className={styles.downState}>No posts for {categoryName.text} yet.</p>}
        <PostGrid posts={visiblePosts} vertical />
        {postsToShow < posts.length && (
          <div className={styles.paginationButtonContainer}>
            <Link className={`button ${styles.paginationButton}`} onClick={handleShowMore} to="#show-more">
              Show more
            </Link>
          </div>
        )}
        {/* <PostGrid
          posts={otherBlogPosts}
          title="Recent posts"
          categoryLink="/"
          categoryLinkText="See more"
          className={styles.suggestedPosts}
        /> */}
      </Section>
      <FooterCta />
    </Layout>
  );
};

export default BlogPost;

export const categoryQuery = graphql`
  query CategoryBySlug($uid: String) {
    category: prismicCategory(uid: { eq: $uid }) {
      id
      uid
      prismicId
      first_publication_date
      last_publication_date
      dataRaw
      data {
        meta_title {
          text
        }
        meta_description {
          text
        }
        ogImage: open_graph_image {
          url
        }
        category_name {
          html
          text
        }
      }
    }
    categoryPosts: allPrismicBlogPost(
      filter: { data: { category: { uid: { eq: $uid } } } }
      sort: { order: DESC, fields: data___date }
    ) {
      nodes {
        uid
        data {
          body {
            ... on PrismicBlogPostDataBodyWysiwyg {
              id
              primary {
                wysiwyg {
                  text
                }
              }
            }
          }
          author {
            url
            document {
              ... on PrismicAuthor {
                id
                data {
                  author_image {
                    url
                    localFile {
                      childImageSharp {
                        gatsbyImageData(quality: 90, layout: CONSTRAINED, width: 2000, placeholder: BLURRED)
                      }
                    }
                  }
                  author_name {
                    text
                    html
                  }
                }
              }
            }
          }
          category {
            document {
              ... on PrismicCategory {
                id
                data {
                  category_name {
                    html
                    text
                  }
                }
                uid
              }
            }
          }
          featured_image {
            url
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 90, layout: CONSTRAINED, placeholder: BLURRED)
              }
            }
          }
          format
          is_popular
          title {
            html
            text
          }
          date(formatString: "MMMM D, YYYY")
        }
      }
    }
    otherPosts: allPrismicBlogPost(
      limit: 6
      sort: { fields: data___date, order: DESC }
      filter: { data: { category: { uid: { ne: $uid } } } }
    ) {
      nodes {
        uid
        data {
          author {
            url
            document {
              ... on PrismicAuthor {
                id
                data {
                  author_image {
                    url
                    localFile {
                      childImageSharp {
                        gatsbyImageData(quality: 90, layout: CONSTRAINED, width: 2000, placeholder: BLURRED)
                      }
                    }
                  }
                  author_name {
                    text
                    html
                  }
                }
              }
            }
          }
          category {
            document {
              ... on PrismicCategory {
                id
                data {
                  category_name {
                    html
                    text
                  }
                }
                uid
              }
            }
          }
          featured_image {
            url
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 90, layout: CONSTRAINED, placeholder: BLURRED)
              }
            }
          }
          format
          is_popular
          title {
            html
            text
          }
          date(formatString: "MMMM D, YYYY")
        }
      }
    }
    newsletterCta: prismicSettings {
      data {
        sign_up_content {
          html
          text
        }
        sign_up_title {
          html
          text
        }
      }
    }
    categoryList: allPrismicCategory {
      nodes {
        data {
          category_name {
            html
            text
          }
        }
        uid
      }
    }
  }
`;
